<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<div
	[class.disabled-container]="isDisabled"
	class="radio-button-group d-flex justify-content-center align-items-center"
	[class.radio-button-group--view-switcher]="variant === 'view-switcher'"
	[ngClass]="options?.btnClass!"
	[ngStyle]="options?.btnStyle!"
>
	<div
		class="btn-group d-flex w-100"
		role="group"
		[ngClass]="'btn-group-' + size"
	>
		<ng-container *ngFor="let buttonsInGroup of buttonGroup; let iLast = last">
			<ng-container *ngFor="let button of buttonsInGroup; let jLast = last">
				<input
					type="radio"
					[ngModel]="value"
					(ngModelChange)="updateValue($event)"
					[value]="button.code"
					class="btn-check"
					[id]="id + button.code"
					[disabled]="isDisabled || button?.disabled!"
				/>
				<label
					class="btn btn-light radio-button-option"
					[for]="id + button.code"
					[class.active]="value === button.code"
					[ngbTooltip]="button?.tooltip"
					[class.me-3]="!iLast && jLast"
				>
					<ng-fa-icon
						*ngIf="button?.faIcon"
						class="radio-button-option-icon"
						[icon]="button.faIcon!"
					></ng-fa-icon>

					<!-- Option name -->
					<span *ngIf="!button?.icon">{{ button.name }}</span>

					<!-- image if available -->
					<img
						*ngIf="button?.icon"
						[src]="button.icon"
						width="21px"
						height="21px"
					/>
				</label>
			</ng-container>
		</ng-container>
	</div>
</div>
